module.exports = __webpack_public_path__ + "img/balance-sheet.a0c53612.svg";